import SendInvitesDialog from './component'
export default SendInvitesDialog



// WEBPACK FOOTER //
// ./src/components/SendInvitesDialog/index.js